import PremiacaoNivel from "@/components/PremiacaoNivel";
export default {
  name: "PremiacaoTabela",
  props: {
    premiados: {
      type: Object,
      required: true
    }
  },
  components: {
    PremiacaoNivel
  }
};